import { render, staticRenderFns } from "./proveedor.vue?vue&type=template&id=af98c30c"
import script from "./proveedor.vue?vue&type=script&lang=js"
export * from "./proveedor.vue?vue&type=script&lang=js"
import style0 from "./proveedor.vue?vue&type=style&index=0&id=af98c30c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports